<template>
  <div id="shake">
    <div class="shakebox">
      <div class="prize">
        <div class="main" :style="'background-image:url('+imgPath+'turntable/turntable1.png)'">
          <div class="tableBox">
            <div class="rotate">
              <img :src="imgPath+'turntable/turntable2.png'" />
            </div>
            <div
              class="tableImg"
              :style="'transform:rotate('+degNum+'deg)'"
              v-dompurify-html="tableImg"
            >{{tableImg}}</div>
            <div class="arrow" @click="prize">
              <img :src="imgPath+'turntable/turntable3.png'" />
            </div>
            <div class="luck">
              <img :src="imgPath+'turntable/turntable4.png'" class="stop" />
            </div>
          </div>
          <template v-if="activeState != 1">
            <p class="center" v-if="act_type == 'fixed'">
              <span v-if="remain !=0">您还有{{remain}}次机会</span>
              <span v-else>{{text}}</span>
            </p>
            <p class="center" v-else>
              <span v-if="allow">点击开始抽奖</span>
              <span v-else>
                下一次抽奖：
                <span class="red">{{hours2}}:{{minites2}}:{{seconds2}}</span>
              </span>
            </p>
          </template>
        </div>
        <div class="prizes" @click="showPrizs()">
          <img :src="imgPath+'luckdraw/prizes.png'" />
          <p>我的奖品</p>
        </div>
      </div>
      <div class="timebox">
        <div class="time" v-if="activeState == -1">
          活动开始倒计时：
          <span class="day">{{days}}</span>天
          <span class="hours">{{hours}}</span>时
          <span class="minute">{{minites}}</span>分
          <span class="second">{{seconds}}</span>秒
        </div>
        <div class="time" v-if="activeState == 0">
          活动结束倒计时：
          <span class="day">{{days}}</span>天
          <span class="hours">{{hours}}</span>时
          <span class="minute">{{minites}}</span>分
          <span class="second">{{seconds}}</span>秒
        </div>
        <div class="time" v-if="activeState == 1">~~~~~~~活动已结束~~~~~~~</div>
      </div>
      <div class="introduce" :style="'background-image:url('+imgPath+'luckdraw/bg4.png)'">
        <div class="rules box">
          <div class="title" :style="'background-image:url('+imgPath+'luckdraw/title-bg.png)'">活动规则</div>
          <p v-dompurify-html="remark">{{remark}}</p>
        </div>
        <div class="copyright">- 由美时美客提供技术支持 -</div>
      </div>
    </div>

    <audio
      src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/musics/bigTurn.mp3"
      class="turnMusic"
      id="turnMusic"
      preload
    ></audio>

    <van-popup v-model="show">
      <prizes :prizelist="prizelist" :prizeRemark="prize_remark"></prizes>
      <div class="close">
        <img @click="closeList" :src="imgPath+'close.png'" />
      </div>
    </van-popup>
    <van-popup v-model="show2">
      <div class="poup center">
        <div class="title">
          <span @click="cutdown"></span>中奖信息
        </div>
        <img v-if="prizeImg" :src="prizeImg" class="prizeImg" />
        <img v-else :src="imgPath+'nothing.jpg'" class="prizeImg" />
        <p v-if="prizeImg">恭喜您，中奖了！！！</p>
        <p v-else>此处空空如也，请再接再厉……</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import tool from "../../kits/Tools.js";
import vxxData from "../../kits/data.js";
import prizes from "./prizes.vue";
import { Toast } from "vant";
import { Popup } from "vant";
Vue.use(Popup);

export default {
  components: {
    prizes,
  },
  data() {
    return {
      aid: "1",
      ds_id: "",
      days: "00",
      hours: "00",
      minites: "00",
      seconds: "00",
      end: false,
      show: false,
      show2: false,
      prizeImg: "",
      start_time: "",
      end_time: "",
      running: false,
      degNum: -90,
      imgList: [],
      imgIndex: 0,
      basicDeg: 0,
      eqIndex: 0,
      interval: 0,
      remark: "",
      prize_remark: "",
      activeState: -1,
      prizelist: [],
      page: 1,
      act_type: "fixed",
      remain: 0,
      hours2: "00",
      minites2: "00",
      seconds2: "00",
      allow: false,
      tableImg: "",
      isWeixin: true,
      loaded: false,
      text: "您的抽奖次数已达上限",
      imgPath: "",
      turnMusic: null,
      timer1: null,
      timer2: null,
    };
  },
  props: ["fansId", "showTable"],
  watch: {
    showTable() {
      if (!this.loaded) {
        Toast.loading({
          mask: true,
          message: "加载中...",
        });

        this.getData();
      }
    },
  },
  mounted() {
    this.imgPath = tool.imgPath();
    this.isWeixin = tool.isWeixin();
    this.ds_id = tool.getQueryDsId();
    this.turnMusic = document.getElementById("turnMusic");
  },
  methods: {
    getData() {
      var that = this;
      var option = "fans_id=" + this.fansId + "&ds_id=" + this.ds_id;
      this.axios
        .post(tool.baseUrl() + "/activity/bigTurnTable/index", option)
        .then(function (res) {
          Toast.clear();
          var data = res.data;
          console.log(data);
          if (data.code == 200) {
            that.loaded = true;
            that.tableImg = data.data.svg;
            that.start_time = data.data.start_time;
            that.end_time = data.data.end_time;
            that.getActiveState(data.data.status);
            that.remark = data.data.remark;
            if (that.remark) {
              that.remark = that.remark.replace(/\n/g, "<br/>");
            }
            that.aid = data.data.aid;
            that.prize_remark = data.data.prize_remark;
            that.act_type = data.data.act_type;
            that.remain = data.data.remain;
            that.interval = data.data.second;
            that.imgList = data.data.prize_list;
            that.imgIndex = that.imgList.length;
            that.basicDeg = parseInt(3600 / that.imgIndex) / 10;
            that.degNum -= that.basicDeg / 2;
            that.timeSwitch();
          } else {
            console.log(data.message);
          }
        })
        .catch(function () {
          //console.log('错误333');
        });
    },
    getActiveState(status) {
      if (status == "not_started") {
        this.activeState = -1;
      } else if (status == "running") {
        this.activeState = 0;
      } else {
        this.activeState = 1;
      }
    },
    prize() {
      var that = this;
      if (!this.isWeixin) {
        Toast("请微信登陆后重试");
        return;
      }
      if (this.activeState == -1) {
        Toast("活动还未开始");
        return false;
      }
      if (this.activeState == 1) {
        Toast("活动已结束");
        return false;
      }
      if (this.act_type != "fixed") {
        if (!this.allow) {
          return false;
        }
      } else {
        if (this.remain <= 0) {
          Toast("您的抽奖次数已达上限");
          return false;
        }
      }
      if (this.running) {
        return false;
      }
      this.running = true;
      that.turnMusic.play();
      var that = this;
      var option =
        "aid=" + this.aid + "&fans_id=" + this.fansId + "&ds_id=" + this.ds_id;
      this.axios
        .post(tool.baseUrl() + "/activity/bigTurnTable/win", option)
        .then(function (res) {
          var data = res.data;
          that.running = false;
          if (data.code == "200") {
            if (that.act_type != "fixed") {
              that.allow = false;
              that.countDown2(that.interval);
            } else {
              that.remain--;
            }
            for (let index in that.imgList) {
              if (that.imgList[index].id == data.data.prize.id) {
                that.degNum =
                  that.degNum -
                  360 * 6 -
                  (parseInt(index) + that.imgIndex - that.eqIndex) *
                    that.basicDeg;
                that.eqIndex = index;
                break;
              }
            }
            that.prizeImg = data.data.prize.pic_url;
            setTimeout(function () {
              if (that.prizeImg) {
                that.show2 = true;
              }
            }, 4000);
          } else {
            Toast(data.message);
            if (data.message == "中奖次数已经达到上限") {
              that.remain = 0;
              that.text = data.message;
            }
          }
        })
        .catch(function () {
          setTimeout(function () {
            that.running = false;
          }, 1000);
          Toast("请求错误");
        });
    },
    timeSwitch() {
      var now = new Date().getTime();
      var start = new Date(this.start_time.replace(/-/g, "/")).getTime();
      var end = new Date(this.end_time.replace(/-/g, "/")).getTime();
      //console.log(now+'--'+start+'--'+end)
      if (this.activeState == -1) {
        this.countDown(parseInt((start - now) / 1000));
        //console.log('未开始');
      } else if (this.activeState == 1) {
        //console.log('已结束');
      } else {
        if (end - now < 0) {
          this.activeState = 1;
        } else {
          this.countDown(parseInt((end - now) / 1000));
          if (this.act_type == "freq") {
            if (this.remain == 0) {
              this.allow = true;
            } else {
              this.countDown2(this.remain);
            }
          }
        }
        //console.log('正在进行');
      }
    },
    countDown(times) {
      clearInterval(this.timer1);
      var that = this;
      console.log(times);
      this.timer1 = setInterval(function () {
        console.log(times);
        if (times != 0) {
          times--;
          that.days = tool.two(Math.floor(times / 24 / 3600));
          that.hours = tool.two(Math.floor((times % (24 * 3600)) / 3600));
          that.minites = tool.two(Math.floor((times % 3600) / 60));
          that.seconds = tool.two(Math.floor(times % 60));
        } else {
          clearInterval(that.timer1);
          that.timeSwitch();
        }
      }, 1000);
    },
    countDown2(time) {
      clearInterval(this.timer2);
      var that = this;
      var times = time;
      this.timer2 = setInterval(function () {
        if (times != 0) {
          times--;
          that.hours2 = tool.two(Math.floor((times % (24 * 3600)) / 3600));
          that.minites2 = tool.two(Math.floor((times % 3600) / 60));
          that.seconds2 = tool.two(Math.floor(times % 60));
        } else {
          clearInterval(that.timer2);
          that.allow = true;
        }
      }, 1000);
    },
    showPrizs() {
      var that = this;
      this.show = true;
      var option =
        "aid=" +
        this.aid +
        "&fans_id=" +
        this.fansId +
        "&type=1" +
        "&page=" +
        this.page;
      //var option = 'fans_id=6';
      this.axios
        .post(tool.baseUrl() + "/activity/bigTurnTable/lists", option)
        .then(function (data) {
          if (data.data.code == "200") {
            that.prizelist = data.data.data.list;
            //console.log('正确11');
          } else {
            //console.log('错误22');
          }
        })
        .catch(function () {
          //console.log('错误33');
        });
    },
    cutdown() {
      this.show2 = false;
      this.prizeImg = "";
    },
    closeList() {
      this.show = false;
    },
    getStatus(status) {
      this.activeState = status;
      this.timeSwitch();
    },
  },
};
</script>

<style scoped>
#shake {
  height: 100%;
  background: #f93d3e;
}

.shakebox {
  height: 100%;
  overflow: scroll;
}

.center {
  text-align: center;
}

img {
  max-width: 100%;
}

.prize {
  min-height: 50%;
  width: 100%;
  overflow: hidden;
  position: relative;
  padding-bottom: 60px;
}

.introduce {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.prizes {
  position: absolute;
  height: 65px;
  text-align: center;
  line-height: 16px;
  color: #fff;
  width: 65px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.3);
  top: 10px;
  left: 20px;
  animation: swing 2s ease-in-out infinite;
  font-size: 12px;
  color: #fff;
}

.prizes img {
  width: 70%;
  margin-top: 5px;
}

@keyframes swing {
  0% {
    transform: rotate(10deg);
  }

  50% {
    transform: rotate(-10deg);
  }

  100% {
    transform: rotate(10deg);
  }
}

.tableBox {
  width: 280px;
  padding-bottom: 280px;
  max-width: 300px;
  position: relative;
  margin: 30px auto 110px;
}

.tableBox .tableImg,
.tableBox .rotate {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.tableBox .tableImg {
  padding: 15px;
  box-sizing: border-box;
  transition: 4s;
}

.tableBox .rotate {
  animation: circle 4s linear infinite;
  box-shadow: 0 0 5px 5px rgba(160, 0, 0, 0.2);
  border-radius: 50%;
  overflow: hidden;
}

@keyframes circle {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.arrow {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -52px;
  margin-left: -31px;
  width: 62px;
}

.luck {
  position: absolute;
  bottom: -110px;
  left: 50%;
  width: 360px;
  margin-left: -180px;
}

.main {
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100%;
}

.main h4 {
  font-size: 18px;
  color: #fff;
  font-weight: bold;
  line-height: 40px;
}

.main p {
  background: #fda513;
  width: 200px;
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  border-radius: 15px;
  margin: 0 auto;
  color: #fff;
}

.timebox {
  position: relative;
  height: 0;
  width: 100%;
  z-index: 100;
}

.time {
  width: 80%;
  position: absolute;
  bottom: -30px;
  left: 50%;
  margin-left: -40%;
  background: #fff;
  border-radius: 3px;
  padding: 20px 5px;
  text-align: center;
  line-height: 20px;
  box-sizing: border-box;
}

.time span {
  display: inline-block;
  background: #f93d3e;
  color: #fff;
  padding: 0 3px;
  border-radius: 2px;
  margin: 0 2px;
}

.introduce {
  background-repeat: no-repeat;
  background-position: center bottom;
  -webkit-background-size: 100%;
  min-height: 50%;
  box-sizing: border-box;
  padding-top: 30px;
  background-size: 100%;
  line-height: 26px;
  color: #9c9c9c;
  position: relative;
  padding-bottom: 80px;
}

.introduce .box {
  width: 90%;
  border: 4px dotted #f3f91f;
  border-radius: 3px;
  margin: 24px auto 0;
  box-sizing: border-box;
  padding: 15px;
  background: #eb6861;
}

.introduce .title {
  background-repeat: no-repeat;
  background-position: center;
  -webkit-background-size: 100% auto;
  background-size: 100% auto;
  line-height: 36px;
  text-align: center;
  color: #f3f91f;
  font-size: 16px;
  font-weight: bold;
}

.introduce p {
  color: #fff;
}

.copyright {
  position: absolute;
  width: 100%;
  bottom: 0;
  text-align: center;
  color: #f93d3e;
}

.prizeImg {
  max-width: 80%;
  margin: 10px 0;
}

.poup {
  background: #fff;
  border-radius: 10px;
  margin: -10px;
  overflow: hidden;
}

.poup .title {
  height: 52px;
  line-height: 52px;
  background: #ff601a;
  color: #fff;
  position: relative;
  font-size: 17px;
  position: relative;
}

.poup .title span {
  height: 20px;
  width: 20px;
  position: absolute;
  transform: rotate(45deg);
  top: 16px;
  right: 20px;
}

.poup .title span:after {
  content: "";
  height: 2px;
  width: 20px;
  background: #fff;
  position: absolute;
  left: 0;
  top: 9px;
}

.poup .title span:before {
  content: "";
  height: 20px;
  width: 2px;
  background: #fff;
  position: absolute;
  top: 0;
  left: 9px;
}

.poup p {
  margin-bottom: 36px;
  font-size: 17px;
}
.turnMusic {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10000;
}
</style>


// WEBPACK FOOTER //
// turntable.vue?fa391618